import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  fullWidth?: boolean;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  fullWidth = false,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-md font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50';
  const variants = {
    primary: 'bg-[#7E3007] text-white hover:bg-[#5a2205] focus-visible:ring-[#7E3007]',
    secondary: 'bg-white text-[#4B280B] hover:bg-gray-100 focus-visible:ring-white',
    outline: 'border-2 border-[#7E3007] text-[#7E3007] hover:bg-[#7E3007] hover:text-white',
    ghost: 'text-[#4B280B] hover:bg-[#4B280B]/5 hover:text-[#4B280B]'
  };
  const sizes = {
    sm: 'h-9 px-3 text-sm',
    md: 'h-11 px-6 text-base',
    lg: 'h-14 px-8 text-lg'
  };
  return <button className={`
        ${baseStyles}
        ${variants[variant]}
        ${sizes[size]}
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} disabled={disabled || isLoading} {...props} data-id="element-328">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-329" />}
      {children}
    </button>;
}